import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  #scrollHandler = null

  connect() {
    this.#scrollHandler = () => {
      this.element.classList.add('is-visible')
      window.removeEventListener('scroll', this.#scrollHandler)
    }
    window.addEventListener('scroll', this.#scrollHandler, { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.#scrollHandler)
  }
}
